// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./Asset/css/color.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 600;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

html,
body {
    overflow: hidden;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #707070;
}

input, select, textarea {
  font-weight: 500 !important;
}

.size-12{
  font-size: 12px;
}
.size-13{
  font-size: 13px;
}
.size-14{
  font-size: 14px;
}

.main-container {
  width: 100vw;
  /* max-width: 1400px; */
  margin: auto;
  height: 100vh;
  overflow: hidden;
  padding: 0;
  background-color:var(--color-7);
}
.section-container {
  width: 100%;
  max-width: 900px;
  margin: auto;
  height: 100%;
  max-height: 600px;
  overflow: hidden;
  padding: 0;
  background-color:#fff;
}

.container-child-wrapper {
  height: 100%;

}

.max-height-for-list-scroll{
  /* max-height:  calc(90vh - 142px); */
  max-height:  400px;
}

.container-with-scroll {
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
}

ul.no-bullets {
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: 1px solid black;
}

#search-results{
  position: absolute;
  overflow: hidden;
  /* overflow-y: auto; */
  background-color: #fff;
  top: 35px;
  left: 0px;
  /* width: 80vw; */
  border: 10px #000 solid;
  z-index: 1;
}

.fixed_headers {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.fixed_headers th {
  text-decoration: underline;
}
.fixed_headers th,
.fixed_headers td {
  padding: 5px;
  text-align: left;
  font-size: 12px;
}
.fixed_headers td:nth-child(1),
.fixed_headers th:nth-child(1) {
  min-width: 50px;
  background-color: #31959ea1;
  color: #fdfdfd;
  font-weight: bold;
}
.fixed_headers td:nth-child(2),
.fixed_headers th:nth-child(2) {
  min-width: 200px;
  background-color: #31959ea1;
  color: #fdfdfd;
  font-weight: bold;
}
.fixed_headers td:nth-child(3),
.fixed_headers th:nth-child(3) {
  min-width: 300px;
}
.fixed_headers td:nth-child(4),
.fixed_headers th:nth-child(4) {
  width: 100%;
}
.fixed_headers thead {
  background-color: #31959ea1;
  color: #fdfdfd;
}
.fixed_headers thead tr {
  display: block;
  position: relative;
}
.fixed_headers tbody {
  display: block;
  overflow: auto;
  width: 100%;
  height: 250px;
}
.fixed_headers tbody tr:hover {
  cursor: pointer;
  /* background-color: #b6b6b6a1 !important; */
}
.fixed_headers tbody tr:nth-child(even) {
  background-color: #ddd;
}


.fixed_headers1 {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.fixed_headers1 th {
  text-decoration: underline;
}
.fixed_headers1 th,
.fixed_headers1 td {
  padding: 5px;
  text-align: left;
  font-size: 12px;
}
.fixed_headers1 td:nth-child(1),
.fixed_headers1 th:nth-child(1) {
  min-width: 80px;
  background-color: #31959ea1;
  color: #fdfdfd;
  font-weight: bold;
  text-align: center;
}

.fixed_headers1 th:nth-child(2) {
  min-width: 200px;
  background-color: #31959ea1;
  color: #fdfdfd;
  font-weight: bold;
}

.fixed_headers1 td:nth-child(2){
  min-width: 200px;
}

/* .fixed_headers1 td:nth-child(3), */
.fixed_headers1 th:nth-child(3) {
  min-width: 100px;
}

.fixed_headers1 td:nth-child(3){
  min-width: 100px;
}

.fixed_headers1 td:nth-child(4),
.fixed_headers1 th:nth-child(4) {
  width: 100%;
  word-break: break-all;
}

.fixed_headers1 thead {
  background-color: #31959ea1;
  color: #fdfdfd;
}
.fixed_headers1 thead tr {
  display: block;
  position: relative;
}
.fixed_headers1 tbody {
  display: block;
  overflow: auto;
  /* width: 100%; */
  /* height: 250px; */
  top: 28px;
  bottom: 0;
  right: 0;
  left: 0;
  position: absolute;
  overflow: hidden;
  overflow-y: auto;
  flex: 1 1;
}
.fixed_headers1 tbody tr:hover {
  cursor: pointer;
  /* background-color: #b6b6b6a1 !important; */
}
.fixed_headers1 tbody tr:nth-child(even) {
  background-color: #ddd;
}



.old_ie_wrapper {
  height: 250px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.old_ie_wrapper tbody {
  height: auto;
}

.wrapper {
  border: 1px solid #d8d8d8;
  position: absolute;
  z-index: 9999999999;
  background-color: white;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}
.outer_div {
  width: 403px;
  background-color: white;
  height: 116px;
  overflow: hidden;   
}
.inner_div {
   overflow-y: scroll;
   overflow-x: hidden;
   max-height: 100%;
   width: 100%;
}
.element {
   width: 100%;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  border-bottom: 1px solid #d8d8d8;
  padding-left: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #646464;   
}
.element-hover {
 background-color: #f5f5f5 !important;   
}

.focused-li{
  background-color: #dbdbdb;
}

.loader-container{
  background: #00000073;
  position: absolute;
  z-index: 1;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-loader {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.custom-loader div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #7cdfe1;
  animation: custom-loader 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.custom-loader div:nth-child(1) {
  left: 8px;
  animation-delay: -0.24s;
}
.custom-loader div:nth-child(2) {
  left: 32px;
  animation-delay: -0.12s;
}
.custom-loader div:nth-child(3) {
  left: 56px;
  animation-delay: 0;
}
@keyframes custom-loader {
  0% {
    top: 8px;
    height: 64px;
  }
  50%, 100% {
    top: 24px;
    height: 32px;
  }
}

.user-select-none-all-child *{
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.resizable{
  resize: both;
  overflow: auto;
}

.truncate-string{
  display: block !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

iframe#webpack-dev-server-client-overlay{display:none!important}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,SAAS;EACT;;cAEY;EACZ,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;;IAEI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,aAAa;AACf;AACA;EACE,eAAe;EACf,4CAA4C;AAC9C;AACA;EACE,sBAAsB;AACxB;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,eAAe;EACf,4CAA4C;AAC9C;AACA;EACE,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EAGvB,0CAA0C;EAK1C,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;AACA;GACG,kBAAkB;GAClB,kBAAkB;GAClB,gBAAgB;GAChB,WAAW;AACd;AACA;GACG,WAAW;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;CACC,oCAAoC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,mEAAmE;AACrE;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE;IACE,QAAQ;IACR,YAAY;EACd;EACA;IACE,SAAS;IACT,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,yCAAyC,sBAAsB","sourcesContent":["@import './Asset/css/color.css';\n\n*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  font-family: 'Roboto', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 600;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nhtml,\nbody {\n    overflow: hidden;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    background-color: #707070;\n}\n\ninput, select, textarea {\n  font-weight: 500 !important;\n}\n\n.size-12{\n  font-size: 12px;\n}\n.size-13{\n  font-size: 13px;\n}\n.size-14{\n  font-size: 14px;\n}\n\n.main-container {\n  width: 100vw;\n  /* max-width: 1400px; */\n  margin: auto;\n  height: 100vh;\n  overflow: hidden;\n  padding: 0;\n  background-color:var(--color-7);\n}\n.section-container {\n  width: 100%;\n  max-width: 900px;\n  margin: auto;\n  height: 100%;\n  max-height: 600px;\n  overflow: hidden;\n  padding: 0;\n  background-color:#fff;\n}\n\n.container-child-wrapper {\n  height: 100%;\n\n}\n\n.max-height-for-list-scroll{\n  /* max-height:  calc(90vh - 142px); */\n  max-height:  400px;\n}\n\n.container-with-scroll {\n  overflow: hidden;\n  overflow-y: auto;\n  height: 100%;\n}\n\nul.no-bullets {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid black;\n}\n\n#search-results{\n  position: absolute;\n  overflow: hidden;\n  /* overflow-y: auto; */\n  background-color: #fff;\n  top: 35px;\n  left: 0px;\n  /* width: 80vw; */\n  border: 10px #000 solid;\n  z-index: 1;\n}\n\n.fixed_headers {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n.fixed_headers th {\n  text-decoration: underline;\n}\n.fixed_headers th,\n.fixed_headers td {\n  padding: 5px;\n  text-align: left;\n  font-size: 12px;\n}\n.fixed_headers td:nth-child(1),\n.fixed_headers th:nth-child(1) {\n  min-width: 50px;\n  background-color: #31959ea1;\n  color: #fdfdfd;\n  font-weight: bold;\n}\n.fixed_headers td:nth-child(2),\n.fixed_headers th:nth-child(2) {\n  min-width: 200px;\n  background-color: #31959ea1;\n  color: #fdfdfd;\n  font-weight: bold;\n}\n.fixed_headers td:nth-child(3),\n.fixed_headers th:nth-child(3) {\n  min-width: 300px;\n}\n.fixed_headers td:nth-child(4),\n.fixed_headers th:nth-child(4) {\n  width: 100%;\n}\n.fixed_headers thead {\n  background-color: #31959ea1;\n  color: #fdfdfd;\n}\n.fixed_headers thead tr {\n  display: block;\n  position: relative;\n}\n.fixed_headers tbody {\n  display: block;\n  overflow: auto;\n  width: 100%;\n  height: 250px;\n}\n.fixed_headers tbody tr:hover {\n  cursor: pointer;\n  /* background-color: #b6b6b6a1 !important; */\n}\n.fixed_headers tbody tr:nth-child(even) {\n  background-color: #ddd;\n}\n\n\n.fixed_headers1 {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n.fixed_headers1 th {\n  text-decoration: underline;\n}\n.fixed_headers1 th,\n.fixed_headers1 td {\n  padding: 5px;\n  text-align: left;\n  font-size: 12px;\n}\n.fixed_headers1 td:nth-child(1),\n.fixed_headers1 th:nth-child(1) {\n  min-width: 80px;\n  background-color: #31959ea1;\n  color: #fdfdfd;\n  font-weight: bold;\n  text-align: center;\n}\n\n.fixed_headers1 th:nth-child(2) {\n  min-width: 200px;\n  background-color: #31959ea1;\n  color: #fdfdfd;\n  font-weight: bold;\n}\n\n.fixed_headers1 td:nth-child(2){\n  min-width: 200px;\n}\n\n/* .fixed_headers1 td:nth-child(3), */\n.fixed_headers1 th:nth-child(3) {\n  min-width: 100px;\n}\n\n.fixed_headers1 td:nth-child(3){\n  min-width: 100px;\n}\n\n.fixed_headers1 td:nth-child(4),\n.fixed_headers1 th:nth-child(4) {\n  width: 100%;\n  word-break: break-all;\n}\n\n.fixed_headers1 thead {\n  background-color: #31959ea1;\n  color: #fdfdfd;\n}\n.fixed_headers1 thead tr {\n  display: block;\n  position: relative;\n}\n.fixed_headers1 tbody {\n  display: block;\n  overflow: auto;\n  /* width: 100%; */\n  /* height: 250px; */\n  top: 28px;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  position: absolute;\n  overflow: hidden;\n  overflow-y: auto;\n  flex: 1;\n}\n.fixed_headers1 tbody tr:hover {\n  cursor: pointer;\n  /* background-color: #b6b6b6a1 !important; */\n}\n.fixed_headers1 tbody tr:nth-child(even) {\n  background-color: #ddd;\n}\n\n\n\n.old_ie_wrapper {\n  height: 250px;\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.old_ie_wrapper tbody {\n  height: auto;\n}\n\n.wrapper {\n  border: 1px solid #d8d8d8;\n  position: absolute;\n  z-index: 9999999999;\n  background-color: white;\n  -webkit-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);\n  -moz-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  -ms-border-radius: 3px;\n  -o-border-radius: 3px;\n  border-radius: 3px;\n}\n.outer_div {\n  width: 403px;\n  background-color: white;\n  height: 116px;\n  overflow: hidden;   \n}\n.inner_div {\n   overflow-y: scroll;\n   overflow-x: hidden;\n   max-height: 100%;\n   width: 100%;\n}\n.element {\n   width: 100%;\n  height: 28px;\n  line-height: 28px;\n  cursor: pointer;\n  border-bottom: 1px solid #d8d8d8;\n  padding-left: 10px;\n  font-weight: 500;\n  font-size: 14px;\n  color: #646464;   \n}\n.element-hover {\n background-color: #f5f5f5 !important;   \n}\n\n.focused-li{\n  background-color: #dbdbdb;\n}\n\n.loader-container{\n  background: #00000073;\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  left: 0;\n  top: 0;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-loader {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.custom-loader div {\n  display: inline-block;\n  position: absolute;\n  left: 8px;\n  width: 16px;\n  background: #7cdfe1;\n  animation: custom-loader 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;\n}\n.custom-loader div:nth-child(1) {\n  left: 8px;\n  animation-delay: -0.24s;\n}\n.custom-loader div:nth-child(2) {\n  left: 32px;\n  animation-delay: -0.12s;\n}\n.custom-loader div:nth-child(3) {\n  left: 56px;\n  animation-delay: 0;\n}\n@keyframes custom-loader {\n  0% {\n    top: 8px;\n    height: 64px;\n  }\n  50%, 100% {\n    top: 24px;\n    height: 32px;\n  }\n}\n\n.user-select-none-all-child *{\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n.resizable{\n  resize: both;\n  overflow: auto;\n}\n\n.truncate-string{\n  display: block !important;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\niframe#webpack-dev-server-client-overlay{display:none!important}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
